import React from "react";
import './Header.css';

/* React router */
import { NavLink } from 'react-router-dom';

/* DarkMode */
import DarkMode from '../DarkMode/DarkMode';

const HeaderPage = () => {
    // Menu desplegable
    const menuDesplegable = () => {
        let navbar = document.querySelector('.navbar');
        navbar.classList.toggle("activar");

        window.onscroll = () => {
            if (window.scrollY > 0) {
                document.querySelector(".site-header").classList.add("activar")
            } else document.querySelector(".site-header").classList.remove("activar")

            navbar.classList.remove("activar")
        }
    }

    return (
        <header className="site-header">
            <div id="menu-btn" className="fas fa-bars" onClick={menuDesplegable}></div>

            <NavLink className="logo" to="" >
                <p>=(<span>Abhay Kumar</span>)=</p>
            </NavLink>

            <nav className="navbar">
                <NavLink to="/">Home</NavLink>
                <NavLink to="/about">About me</NavLink>
                <NavLink to="/service">Services</NavLink>
                <a href="/#proyectos" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>Projects</a>
            </nav>
            <div className="switch" id="switch">
                <DarkMode />
            </div>
        </header>
    )
}

export default React.memo(HeaderPage);